module.exports = {"330104005":"凯旋街道","330104006":"采荷街道","330104007":"闸弄口街道","330104008":"四季青街道","330104009":"白杨街道","330104010":"下沙街道","330104011":"彭埠街道","330104012":"笕桥街道","330104013":"丁兰街道","330104014":"九堡街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330104.json
// module id = 1043
// module chunks = 0